<div class="relative w-full">
  <div
    #reference
    class="border-default bg-surface flex max-h-40 flex-wrap gap-2 overflow-y-auto rounded-lg border p-2">
    @for (label of selectedItems(); track label) {
      @let tag = tagsByLabel().get(label);
      <div
        class="inline-flex items-center gap-1.5 rounded px-2 py-0.5 text-sm text-white"
        [style.background-color]="tag?.color ?? '#6366f1'">
        <span>{{ label }}</span>
        <button
          type="button"
          (click)="removeTag(label)"
          class="ml-1 inline-flex h-4 w-4 items-center justify-center rounded-full opacity-80 hover:opacity-100">
          <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    }
    <input
      type="text"
      class="text-text-primary placeholder-text-tertiary min-w-[120px] flex-1 border-0 bg-transparent text-sm outline-none focus:ring-0"
      [id]="id()"
      [placeholder]="'form.tags_placeholder' | translate"
      [value]="searchText()"
      (keydown)="onKeyDown($event)"
      (blur)="onInputBlur()"
      (focus)="onInputFocus()"
      (input)="onSearchInput($event)" />
  </div>

  @if (isDropdownOpen()) {
    <div
      #dropdown
      data-testid="tags-dropdown"
      class="border-default bg-elevated fixed top-0 left-0 z-500 max-h-60 overflow-auto rounded-lg border shadow-lg">
      @for (tag of filteredOptions(); track tag.id; let i = $index) {
        <div
          (click)="selectTag(tag.label)"
          (keydown.enter)="selectTag(tag.label)"
          [class.bg-interactive]="i === highlightedIndex()"
          class="text-text-primary hover:bg-interactive flex cursor-pointer items-center gap-2 px-4 py-2.5 text-sm">
          <span
            class="inline-block h-3 w-3 shrink-0 rounded-full"
            [style.background-color]="tag.color"></span>
          <span>{{ tag.label }}</span>
        </div>
      } @empty {
        <div class="text-text-tertiary px-4 py-2.5 text-sm">
          {{ 'common.no_items' | translate }}
        </div>
      }
    </div>
  }
</div>
